<template>
  <b-nav-item-dropdown class="dropdown-notification mr-25" menu-class="dropdown-menu-media" right>
    <template #button-content>
      <feather-icon
        :badge="unreadsLength"
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          {{ t('Notifications') }}
        </h4>
        <b-badge pill variant="light-primary"> {{ unreadsLength }} {{ t('New') }} </b-badge>
      </div>
    </li>

    <!-- Notifications -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
      @scroll="handleScroll"
    >
      <!-- Account Notification -->
      <b-link v-for="(notification, index) in notifications" :key="index">
        <b-media class="pl-2 py-2">
          <p class="media-heading">
            <span class="font-weight-bolder">
              {{ notification.title }}
            </span>
          </p>
          <small class="notification-text">{{ notification.content }}</small>
        </b-media>
      </b-link>
    </vue-perfect-scrollbar>
    <div v-if="loading" class="d-flex flex-column align-items-center justify-content-center my-3">
      <b-spinner type="border" label="Spinning" />
    </div>

    <!-- Cart Footer -->
    <li class="dropdown-menu-footer">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        block
        :disabled="readSubmitting"
        @click="readAllNotificationsRequest()"
      >
        {{ t('Read all notifications') }}
      </b-button>
    </li>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BBadge, BMedia, BLink, BButton, BSpinner } from 'bootstrap-vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Ripple from 'vue-ripple-directive';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import useService from '@/auth/service/useService';

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    VuePerfectScrollbar,
    BButton,
    BSpinner
  },

  directives: {
    Ripple
  },

  data() {
    return {
      readSubmitting: false,
      notifications: [],
      unreadsLength: 0,
      totalRecords: 0,
      params: {
        page: 1,
        limit: 10
      },
      loading: false
    };
  },

  created() {
    this.notificationsRequest();
    this.unreadNotificationRequest();
  },

  methods: {
    notificationsRequest() {
      useService.getAllNotifications(this.params).then(response => {
        this.notifications = response.data;
        this.totalRecords = response.meta.total;
      });
    },

    unreadNotificationRequest() {
      useService.getAllUnreadNotifications().then(response => {
        this.unreadsLength = response.data.length;
      });
    },

    readAllNotificationsRequest() {
      this.readSubmitting = true;
      useService.readAllNotifications().finally(() => {
        this.readSubmitting = false;
        this.unreadNotificationRequest();
      });
    },

    handleScroll() {
      const bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight ===
        document.documentElement.offsetHeight;
      if (bottomOfWindow && !this.loading) {
        this.loadMoreNotifications();
      }
    },

    loadMoreNotifications() {
      if (this.notifications.length < this.totalRecords) {
        this.loading = true;

        setTimeout(() => {
          this.params.page++;
          useService.getAllNotifications(this.params).then(response => {
            this.notifications = this.notifications.concat(response.data);
            this.loading = false;
          });
        }, 1000);
      }
    }
  },
  setup() {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false
    };

    const { t } = useI18nUtils();

    return {
      perfectScrollbarSettings,
      t
    };
  }
};
</script>

<style></style>
